import React from "react";
import Card from "../../../card/card";

const MobileTopTen = ({ cardsData, type, section_type }) => {
  return (
    <div className="grid grid-cols-2 justify-center gap-y-1">
      {cardsData?.map((item, index) => {
        return (
          <div className="w-fit mx-auto" key={item?.id}>
            <Card
              type={type}
              key={`card-${index + 1}`}
              cardData={item}
              index={index}
              section_type={section_type}
            />
          </div>
        );
      })}
    </div>
  );
};

export default MobileTopTen;
